export default function decorateHashAndMentions(text: string) {
  return text.replace(/\s([@#][\w_-]+)/g, "<span class='hashtag'>$1 </span>");
}
